import React from "react";
import { useTranslation } from "react-i18next";

const BaccaratWin = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`promotions.baccaratWinPromotion.content.${key}`);

  const data = [
    { month: 6, amount: "999,000" },
    { month: 8, amount: "5,880,000" },
    { month: 10, amount: "16,800,000" },
    { month: 15, amount: "26,660,000" },
  ];
  return (
    <div className="w-full">
      {/* <h1 className="text-2xl font-bold mb-4">{i18n("activityInfo")}</h1>

      <div className="mb-4">
        <div className="font-semibold">{i18n("startTime")}</div>
        <div>{i18n("officialStart")}</div>
        <div>{i18n("welcome")}</div>
      </div> */}

      <h1 className="text-2xl font-bold mb-4">{i18n("gameInfo")}</h1>

      <div className="mb-4">
        <div className="font-semibold">{i18n("allGames")}</div>
      </div>

      <div className="mb-4">
        <h1 className="text-2xl font-bold mb-4">{i18n("detail")}</h1>
        <table className="min-w-full border border-gray-300">
          <thead>
            <tr>
              <th className="border px-4 py-2">{i18n("consecutive")}</th>
              <th className="border px-4 py-2">{i18n("amount")}</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td className="border px-4 py-2 text-center">
                  {i18n("consecutive")}
                  {item.month}
                  {i18n("game-row")}
                </td>
                <td className="border px-4 py-2 text-center">
                  {i18n("plus")}
                  {item.amount}
                  {i18n("forYou")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* <h1 className="text-2xl font-bold mb-4">{i18n("howToGet")}</h1>

      <div className="mb-4">
        <div className="font-semibold">{i18n("claimCondition")}</div>
      </div> */}

      <div className="mb-4">
        <h2 className="text-2xl font-bold mb-4">{i18n("ruleTitle")}</h2>

        <ol className="list-decimal pl-5">
          <li className="mb-2">{i18n("rule1")}</li>
          <li className="mb-2">{i18n("rule2")}</li>
          <li className="mb-2">
            {i18n("rule3")}
            {/* <p className="text-red-500 mt-1">{i18n("rule3Note")}</p> */}
          </li>
          <li className="mb-2">{i18n("rule4")}</li>
          <li className="mb-2">{i18n("rule5")}</li>
          {/* <li className="mb-2">{i18n("rule6")}</li>
          <li className="mb-2">{i18n("rule7")}</li>
          <li className="mb-2">{i18n("rule8")}</li>
          <li className="mb-2">{i18n("rule9")}</li>
          <li className="mb-2">{i18n("rule10")}</li> */}
        </ol>
      </div>

      <div className="mb-4">
        <h2 className="text-2xl font-bold mb-4">{i18n("ruleTitle2")}</h2>

        <ul className="list-disc pl-5 mt-2">
          <li className="mb-4">{i18n("rule2-1")}</li>
          <li className="mb-4">{i18n("rule2-2")}</li>
          <li className="mb-4">{i18n("rule2-3")}</li>
          <li className="mb-4">{i18n("rule2-4")}</li>
        </ul>
      </div>
    </div>
  );
};

export default BaccaratWin;
